import { VuexModule, Module, Mutation, Action } from 'vuex-class-modules'

export class Model<T> extends VuexModule {
  entities: T[] = [] // { [id: string]: T[] }
  entitiesById: { [id: string]: T } = {}
  entitiesLoaded: boolean = false

  @Mutation STORE_ENTITIES(entities: T[]) {
    this.entities = entities
    entities.forEach((entity) => {
      const { id } = entity as any
      if (id) {
        this.entitiesById[id] = entity
      }
    })
    this.entitiesLoaded = true
  }

  @Mutation STORE_ENTITY(entity: T) {
    const { id } = entity as any
    const entityIfExists = this.entitiesById[id]
    if (entityIfExists) {
      entity = { ...entityIfExists, ...entity }
    }
    this.entities = Object.values(this.entitiesById)
  }

  @Mutation INDEX_ENTITIES({ indexBy, key }: { indexBy: string|((entity: T) => Array<string|number>), key: string }) {
    const index: { [key: string]: T[] } = {}
    this.entities.forEach((entity) => {
      let indexKeys = []
      switch (typeof indexBy) {
        case 'string':
          indexKeys = (entity as any)[indexBy]
          break
        case 'function':
          indexKeys = indexBy(entity)
          break
      }
      indexKeys = Array.isArray(indexKeys) ? indexKeys : [indexKeys]
      indexKeys.forEach((indexKey) => {
        if (index[indexKey] === undefined) { index[indexKey] = [] }
        index[indexKey].push(entity)
      })
    });
    (this as any)[key] = index
  }
}
